<template>
  <div>
    <!-- 添加/编辑-类目： -->
    <el-dialog :title="isAdd ? $t('message.addCategory') : $t('message.editCategory')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="580px" center>
      <div class="content">

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 排序 -->
          <el-form-item :label="$t('message.sort')" prop="sort">
            <el-input v-model="ruleForm.sort" style="width: 100px;"></el-input>
            <span style="color: #c35257;">*数字越大越靠前</span>
          </el-form-item>
          <!-- 类目名 -->
          <el-form-item :label="$t('message.categoryName')" prop="name">

            <el-input v-model="ruleForm.name" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
      $t("message.cancel")
    }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="categoryAdd" v-if="isAdd">{{
      $t("message.ok")
    }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="categoryEdit" v-else>{{
      $t("message.ok")
    }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    isAdd: { type: Boolean }
  },
  data() {
    return {
      ruleForm: {

      },
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {

    // 新增
    categoryAdd() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.categoryAdd(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.articleList()
          });
        }
      })

    },
    // 修改
    categoryEdit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.categoryEdit(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.articleList()
          });
        }
      })

    },
    acceptData(data) {
      this.ruleForm = data
      this.dialogVisible = true
    }

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


}
</style>